import React from "react";
import { Group, Text } from "@mantine/core";

interface NonSortableHeaderProps {
  column: any;
  label: string;
  ta?: "left" | "center" | "right";
}

const NonSortableHeader: React.FC<NonSortableHeaderProps> = (props) => {
  const { label, ta } = props;
  return (
    <Group align="center" justify={ta === "right" ? "flex-end" : "space-between"}>
      <Text ta={ta} size="sm">
        {label}
      </Text>
    </Group>
  );
};

export default NonSortableHeader;
